import { connect } from 'react-redux';
import { compose, withHandlers } from 'recompose';
import { getRoleIdType } from '../../auth/selectors';
import openLinkInNewWindow from '../../common/helpers/openLinkInNewWindow';
import withToggle from '../../common/hoc/withToggle';
import {
  closeLoansDrawer,
  declineOffer,
  fetchLoansLink,
  hideLoansPopup,
} from '../actions';
import LoansDrawer from './LoansDrawer';
import {
  getIsDrawerOpened,
  getLoanOffer,
  getLoansList,
} from '../selectors';
import { getAvailableLoanAmount, getAvailableLoanLinkType } from '../utils';
import { LOAN_STATUS } from '../constants';

const mapStateToProps = state => ({
  userHasPaidOutLoan: getLoansList(state).some(loan => loan.status === LOAN_STATUS.PAID_OUT),
  amount: getAvailableLoanAmount(getLoanOffer(state)),
  shopOrBarber: getRoleIdType(state),
  opened: getIsDrawerOpened(state),
  linkType: getAvailableLoanLinkType(getLoanOffer(state)),
});

const mapDispatchToProps = {
  fetchLoansLink,
  hideLoansPopup,
  closeLoansDrawer,
  declineOffer,
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withToggle('generatingLink'),
  withToggle('decliningOffer'),
  withToggle('disclaimerVisible'),
  withToggle('declineConfirmVisible'),
  withHandlers({
    onCloseDrawer: props => () => {
      props.hideLoansPopup(props.shopOrBarber.id, props.shopOrBarber.type).finally(
        () => props.closeLoansDrawer()
      );
      props.disclaimerVisibleOff();
      props.declineConfirmVisibleOff();
    },
    onApplyClick: props => () => {
      props.generatingLinkOn();

      props.fetchLoansLink(props.shopOrBarber.id, props.shopOrBarber.type, props.linkType)
        .then(({ url }) => {
          openLinkInNewWindow(url);

          props.closeLoansDrawer();
        })
        .finally(() => props.generatingLinkOff());
    },
    onDeclineClick: props => () => {
      props.declineConfirmVisibleOff();
      props.decliningOfferOn();

      props.declineOffer(props.shopOrBarber.id, props.shopOrBarber.type)
        .then(() => {
          props.closeLoansDrawer();
        })
        .finally(() => props.decliningOfferOff());
    },
  })
)(LoansDrawer);
